import React from "react";

const About = function () {
  return (
    <div className="mt-4">
      <h2>About This App</h2>
      <p>App to search Github users</p>
      <p>App Version 1.2.1</p>
      <p>React 18.2.0</p>
      <p>React Router 6.10.0</p>
    </div>
  );
};

export default About;
